import firedux from '../firedux'

import {
  GROUP_CHAT_BOOKMARKS_ENDPOINT
} from '../../config/constants'

export default (uid, groupId) => {
  if (!uid || !groupId) return Promise.reject()

  const ref = firedux.ref.child(GROUP_CHAT_BOOKMARKS_ENDPOINT).child('users').child(uid).child(groupId)

  return ref.set(true)
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/setters/bookmark_group.js
 **/